/* eslint-disable */
export const handleValidation = (inputFields) => {
  let fields = inputFields;
  let errors = {};
  let individualInputErrors = {}
  let formIsValid = true;
  //Name
  if (!fields["name"]) {
    formIsValid = false;
    errors["name"] = "Cannot be empty";
    individualInputErrors["name"] = true
  }

  if (!fields["age"]) {
    formIsValid = false;
    errors["age"] = "Cannot be empty";
    individualInputErrors["age"] = true
  }
  if (!fields["regDate"]) {
    formIsValid = false;
    errors["regDate"] = "Cannot be empty";
    individualInputErrors["regDate"] = true
  }
  if (!fields["gender"]) {
    formIsValid = false;
    errors["gender"] = "Cannot be empty";
    individualInputErrors["gender"] = true
  }
  if (!fields["mobile"]) {
    formIsValid = false;
    errors["mobile"] = "Cannot be empty";
    individualInputErrors["mobile"] = true
  }

  if (typeof fields["mobile"] !== "undefined") {
    if (!fields["mobile"].match(/^([+]\d{2})?\d{10}$/)) {
      formIsValid = false;
      errors["mobile"] = "Please Enter Valid Mobile Number";
      individualInputErrors["mobile"] = true
    }
  }

  if (fields["age"]) {
    if (Number(fields["age"]) > 0 && Number(fields["age"]) <= 100) {
      formIsValid = true;
    } else {
      formIsValid = false;
      errors["age"] = "Please Enter Valid Age Number";
      individualInputErrors["mobile"] = true
    }
  }

  return { formIsValid, errors, individualInputErrors };
}

